window.swymCallbackFn = function(swat) {
  // your API calls go here
  attachNotifyMeEvents();

  function attachNotifyMeEvents() {
    var swymNotifyMeBtn = document.querySelectorAll("[data-swym-custom-watchlist]");
    swymNotifyMeBtn.forEach(function (btn) {
      btn.addEventListener("click", addToWatchlist);
      btn.classList.add("swym-loaded");
    });
  }

  function addToWatchlist(eventObj) {
    eventObj.preventDefault();
    var productId = +eventObj.target.getAttribute("data-product-id");
    var variantId = +eventObj.target.getAttribute("data-variant-id");
    var du = eventObj.target.getAttribute("data-url");
    var params = {
      empi: productId,
      epi: variantId,
      du: du
    };

    swat.getProductDetails(params, function (productJSON) {
      productJSON.variants.forEach(function (v) {
        if (v.id == variantId) {
          params.pr = SwymUtils.formatProductPrice(v.price);
          params.iu = productJSON.featured_image;
          params.et = 8;
          swat.addToWatchList(eventObj, params, function (e) {
            console.log("Subscribed to product!", e);
          }); // Shows Subscribe me.
          return;
        }
      });
    });
  }
}

export function attachBIS() {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  } else {
    window.SwymCallbacks.filter(cb => typeof cb !== "function");
  }
  window.SwymCallbacks.push(window.swymCallbackFn);
}